<template>
    <div>
        <div class="row">
            <div class="col">
                <p class="my-4" v-html="sticker.short_description"></p>
            </div>
        </div>
        <div
            v-if="parseInt(sticker.textile) === 1"
            class="row align-items-center my-4 pb-4 border-bottom"
            id="textile"
        >
            <div class="col-12 col-xl">
                <strong>{{ $t("Textil felületekre") }}</strong>
                <div class="mb-3">
                    <small v-html="sticker.textile_description"></small>
                </div>
                <div class="mb-3">
                    <small>{{ $t("30 db / csomag") }}</small>
                </div>
            </div>
            <div class="col-8 col-xl-auto d-flex align-items-center">
                <div class="number-input-holder">
                    <button
                        class="btn btn-simple sub"
                        v-on:click="removeQty('qty_textile')"
                    >
                        -
                    </button>
                    <div class="product-quantity">
                        <input
                            class="form-control"
                            type="number"
                            :value="model.qty_textile"
                            v-on:input="
                                setQty('qty_textile', $event.target.value)
                            "
                            min="0"
                            :aria-label="$t('Mennyiség')"
                        />
                    </div>
                    <button
                        class="btn btn-simple add"
                        v-on:click="addQty('qty_textile')"
                    >
                        +
                    </button>
                </div>
                <div class="mx-3">
                    {{ $t("csomag") }}
                </div>
            </div>
            <div class="col-4 col-xl-auto text-end">
                <strong class="price">{{ sticker.price_textile }} Ft</strong>
            </div>
        </div>
        <div
            v-if="parseInt(sticker.plastic) === 1"
            class="row align-items-center my-4 pb-4 border-bottom"
            id="plastic"
        >
            <div class="col-12 col-xl">
                <strong>{{ $t("Műanyag felületekre") }}</strong>
                <div class="mb-3">
                    <small v-html="sticker.plastic_description"></small>
                </div>
                <div class="mb-3">
                    <small>{{ $t("30 db / csomag") }}</small>
                </div>
            </div>
            <div class="col-8 col-xl-auto d-flex align-items-center">
                <div class="number-input-holder">
                    <button
                        class="btn btn-simple sub"
                        v-on:click="removeQty('qty_plastic')"
                    >
                        -
                    </button>
                    <div class="product-quantity">
                        <input
                            class="form-control"
                            type="number"
                            :value="model.qty_plastic"
                            v-on:input="
                                setQty('qty_plastic', $event.target.value)
                            "
                            min="0"
                            :aria-label="$t('Mennyiség')"
                        />
                    </div>
                    <button
                        class="btn btn-simple add"
                        v-on:click="addQty('qty_plastic')"
                    >
                        +
                    </button>
                </div>
                <div class="mx-3">
                    {{ $t("csomag") }}
                </div>
            </div>
            <div class="col-4 col-xl-auto text-end">
                <strong class="price">{{ sticker.price_plastic }} Ft</strong>
            </div>
        </div>
        <div class="text-end small text-muted" v-if="minOrder > 1">
            {{ $t("Minimális rendelhető mennyiség: ") }}{{ minOrder }}
        </div>
    </div>
</template>

<script>
export default {
    name: "DownSide",
    props: ["model", "sticker"],
    computed: {
        minOrder() {
            return parseInt(this.sticker.min_order) || 1;
        }
    },
    methods: {
        setQty(type, value) {
            const qty = Math.max(0, parseInt(value, 10) || 0);
            this.$emit("update", { [type]: qty });
        },
        removeQty(type) {
            this.setQty(type, this.model[type] - 1);
        },
        addQty(type) {
            this.setQty(type, this.model[type] + 1);
        }
    }
};
</script>

<style scoped></style>
